module.exports = __webpack_public_path__ + "assets/coupon_select.273b62a9.svg";